
import { Vue, Component, Prop } from 'vue-property-decorator';
import { createWidget } from '@typeform/embed';
import '@typeform/embed/build/css/widget.css';
import { State } from 'vuex-class';
import { IUser } from '~/store/profile/types';
import { IWallet } from '~/store/inventory/types';

@Component
export default class TypeformEmbed extends Vue {
  @State((profile) => profile.user, { namespace: 'profile' })
  currentUser!: IUser;

  @State('wallets', { namespace: 'inventory' })
  private wallets!: IWallet[];

  @Prop(String) typeFormId!: string;
  @Prop({ type: Object, default: () => {} }) typeFormEmbedOpts!: object;

  get lzTargetId() {
    return `typeform_${this.typeFormId}`;
  }

  get hiddenFields() {
    if (!this.currentUser.loggedIn)
      return {
        user_id: '',
        display_name: '',
        email: '',
        eth_address: '',
        is_logged_in: 'N',
      };

    return {
      user_id: this.currentUser.id ?? '',
      display_name: this.currentUser.displayName ?? '',
      email: this.currentUser.email ?? '',
      eth_address: this.ethAddress ?? '',
      is_logged_in: 'Y',
    };
  }

  get ethAddress() {
    return this.wallets.find((wallet) => wallet.symbol === 'ETH')
      ?.receiveAddress;
  }

  mounted() {
    const el = this.$refs?.typeformEmbed as HTMLElement;
    createWidget(this.typeFormId, {
      container: el,
      hidden: this.hiddenFields,
      onSubmit: (data) => {
        this.$emit('submit', data.responseId);
      },
      ...this.typeFormEmbedOpts,
    });
  }
}
